import React from 'react';
import PropTypes from 'prop-types';
import './ReviewRating.scss';
import cn from 'classnames';

const dotWidthForRating = (idx, rating) => {
  if (rating >= idx + 1) {
    return '100%';
  } else if (rating < idx) {
    return '0%';
  }
  return `${(rating - Math.floor(rating)) * 100}%`;
};

export const ReviewRating = ({ rating, size = 12 }) => {
  return (
    <div className='review-rating' aria-label={`Rating: ${rating} out of 5`}>
      {[0, 1, 2, 3, 4].map(idx => (
        <div key={idx} className={cn('review-rating-dot', `size-${size}`)}>
          <div className='review-rating-dot-inner' style={{ width: dotWidthForRating(idx, rating) }} />
        </div>
      ))}
    </div>
  );
};

ReviewRating.propTypes = {
  rating: PropTypes.number.isRequired,
  size: PropTypes.number
};
